export default "__VITE_ASSET___KIvJoh4__"